import axios, { AxiosResponse } from 'axios';
import NProgress from '@/config/nprogress';
import { showLoading, hideLoading } from '@/config/serviceLoading';
import { Message } from '@arco-design/web-react';
import { checkStatus } from '@/helper/checkStatus';
import { whiteListRequest } from './whiteListRequest';
const {
  VITE_PROXY_URL,
  VITE_API_URL_PREFIX,
  VITE_APP_AID = 0,
} = import.meta.env;

console.log(
  '===================',
  VITE_APP_AID,
  VITE_PROXY_URL,
  VITE_API_URL_PREFIX
);

// 定义接口类型
declare module 'axios' {
  interface AxiosRequestConfig {
    /**@name loading 是否展示加载 */
    loading?: boolean;
  }
}

// 创建axios实例
const service = axios.create({
  baseURL: `${VITE_PROXY_URL}${VITE_API_URL_PREFIX}`,
  timeout: 10000,
  withCredentials: false, // 跨域请求时是否需要使用凭证
});

// 隐藏所有loading
const hideAllLoading = (message?: string) => {
  setTimeout(() => {
    hideLoading(() => {
      if (message) Message.error(message);
      NProgress.done();
    });
  }, 200);
};

// 请求拦截器
service.interceptors.request.use((config) => {
  // 网页加载效果
  showLoading(config?.loading, () => {
    NProgress.start();
  });
  // 请求头配置
  const _headers = { ...config.headers };
  // 添加接口白名单，不需要 Token 验证的接口地址列表
  const isWhitelisted = whiteListRequest.some((route) => {
    return route === config.url;
  });
  console.log('isWhitelisted', isWhitelisted, VITE_APP_AID);

  _headers['Aid'] = VITE_APP_AID;
  const search: any = new URLSearchParams(location.search);
  const token = search.get('token') ?? localStorage.getItem('Token');

  if (!isWhitelisted) {
    // const token =  localStorage.getItem('Token');

    if (token) {
      _headers['Token'] = token;
    }
  }
  config.headers = _headers;
  // mock需要 ！！！后期删除
  // _headers['X-Access-Token'] = 'xxxx';
  return config;
});

// 响应拦截器
service.interceptors.response.use(
  (response: AxiosResponse) => {
    const { data } = response;
    // 失败返回
    if (data.code != 0) {
      // 无权限
      if (data.code === 401) {
        window.localStorage.clear();
        const pathName = window.location.pathname;
        if (pathName !== '/login') {
          window.location.href = '/login';
        }
        hideAllLoading('登录过期，请重新登录');
        return Promise.reject(data);
      }
      hideAllLoading(data?.message);
      return Promise.reject(data);
    }
    hideAllLoading();
    return data;
  },
  (error) => {
    const { response } = error;
    if (response && response.status === 401) {
      if (window.electron) {
        window.electron.ipcRenderer.send('logout');
      }
      window.localStorage.clear();
      const pathName = window.location.pathname;
      if (pathName !== '/login') {
        window.location.href = '/login';
      }
      hideAllLoading();
      return Promise.reject(error);
    }
    if (response && response.status === 400) {
      hideAllLoading();
      return Promise.reject(response.data.message);
    }
    // 根据响应的错误状态码，做不同的处理
    if (response) checkStatus(response.status);
    // 断网处理
    if (!window.navigator.onLine) window.location.href = '/500';
    hideAllLoading();
    return Promise.reject(error);
  }
);

export default service;
